import React from "react";
import { Box, Fade, Modal, IconButton } from "@mui/material";
import ReactJson from "react-json-view";
import { IoMdClose } from "react-icons/io";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  maxHeight: "80vh",
  overflow: "auto",
  outlinr: "none",
};

const JsonPopupModal = ({ open, handleClose, jsonData, title }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      aria-labelledby="json-modal-title"
      aria-describedby="json-modal-description"
    >
      <Fade in={open}>
        <Box sx={style} position="relative">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <IoMdClose />
          </IconButton>

          <h2 id="json-modal-title" style={{ marginTop: 0 }}>
            {title}
          </h2>

          <ReactJson
            src={jsonData}
            theme="monokai"
            collapsed={1}
            enableClipboard={false}
            displayDataTypes={false}
            displayObjectSize={false}
          />
        </Box>
      </Fade>
    </Modal>
  );
};

export default JsonPopupModal;
